import { SET_CURRENT_TABLE_CELL } from "store/constans";
import { setCustomParameterValues } from "utils/builder/IScheduleLogic";
import { logError } from "utils/builder/IAmecLog";

export const reconcileExternalEditsMiddleware = () => (next) => async (action) => {
  const isRemote = action?.meta?.source === "remote";
  const isExternalWindow =
    typeof window !== "undefined" && window.__IS_EXTERNAL_TABLE_WINDOW__;

  if (isRemote && !isExternalWindow && action.type === SET_CURRENT_TABLE_CELL) {
    try {
      const { columnId, lineElements, newValue } = action.payload || {};
      if (columnId && Array.isArray(lineElements) && lineElements.length) {
        await setCustomParameterValues(columnId, lineElements, newValue);
      }
    } catch (err) {
      logError("reconcileExternalEditsMiddleware", err?.toString?.() || String(err));
    }
  }

  return next(action);
};